import React from 'react'
import ListaTodos from '../components/ListaTodos'

const todos = () => {
  return (
    <ListaTodos />
  )
}

export default todos